import React from 'react';
import PropTypes from 'prop-types';
import Modal from './Modal';
import translate from '../translate';
import ModalHeader from './ModalHeader';
import ModalFooter from './ModalFooter';
import withCSRF from '../withCSRF';
import { compose } from '../../services/utilityFunctions';

const RemoveDocumentModal = ({
  t,
  onClose,
  onUpdate,
  isLoading,
  documentName,
}) => (
  <Modal id="remove-document-modal" onClose={() => onClose(false)} tabIndex={0}>
    <div
      className="modal-dialog modal-dialog-centered modal-lg market-modal-remove"
      role="document"
    >
      <div
        className="modal-content"
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
        }}
      >
        <ModalHeader
          title={t('modal.remove.document.title')}
          onClose={() => onClose(false)}
        />
        <div className="modal-body">
          <p>{t('modal.remove.document.content', documentName)}</p>
        </div>
        <ModalFooter
          saveIsLoading={isLoading}
          disabledSave={isLoading}
          onCancel={() => onClose(false)}
          onSave={onUpdate}
          cancelText={t('cancel')}
          saveText={t('remove')}
        />
      </div>
    </div>
  </Modal>
);

RemoveDocumentModal.propTypes = {
  t: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  onUpdate: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  documentName: PropTypes.string.isRequired,
};

RemoveDocumentModal.defaultProps = {
  isLoading: false,
};

export default compose(withCSRF, translate)(RemoveDocumentModal);
